/**
 *
 * Asynchronously loads the component for VoiceModelsPage
 *
 */

import { lazyLoad } from 'utils/loadable';

// Add error handling for chunk loading failures
const loadWithRetry = async (importFunc: () => Promise<any>, retries = 3) => {
  for (let i = 0; i < retries; i++) {
    try {
      return await importFunc();
    } catch (error) {
      console.warn(`Chunk loading attempt ${i + 1} failed:`, error);

      // If this is the last attempt, throw the error
      if (i === retries - 1) {
        throw error;
      }

      // Wait a bit before retrying (exponential backoff)
      await new Promise(resolve => setTimeout(resolve, Math.pow(2, i) * 1000));
    }
  }
};

export const VoiceModelsPage = lazyLoad(
  () => loadWithRetry(() => import('./index')),
  module => module.VoiceModelsPage,
);
